import { render, staticRenderFns } from "./UiTabs.vue?vue&type=template&id=4919a9f8&lang=pug&"
import script from "./UiTabs.vue?vue&type=script&lang=js&"
export * from "./UiTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4919a9f8')) {
      api.createRecord('4919a9f8', component.options)
    } else {
      api.reload('4919a9f8', component.options)
    }
    module.hot.accept("./UiTabs.vue?vue&type=template&id=4919a9f8&lang=pug&", function () {
      api.rerender('4919a9f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/interface/UiTabs.vue"
export default component.exports